import { DetailSection } from '../../shared/components';
import { OnrampDepositDetailsSlideOverWidget } from '../bill/OnrampDepositDetails.SlideOverWidget';
import { toast } from 'react-toastify';
import { useDialog } from 'shared/components/Dialog';
import { useDeleteTransfer, useTransfers } from './useTransfers';
import { isCryptoCurrency } from '../bill/lib';
import { Drawer } from 'antd';
import { PayoutDetailsWidget } from 'features/payments/PayoutDetailsWidget';

export const TransferOverviewSlideOver = ({
  onClose,
  onCompleteTransferClick,
  transfer,
}) => {
  const dialog = useDialog();
  const { invalidate } = useTransfers();
  const { deleteTransfer } = useDeleteTransfer();
  const handleDelete = async () => {
    const confirmationText = 'Are you sure you want to delete this transfer?';

    dialog.confirm({
      title: 'Delete transfer',
      desc: confirmationText,
      onConfirm: async () => {
        try {
          await deleteTransfer(transfer.id);
          await invalidate();
          toast.success('Transfer Deleted!');
          onClose();
        } catch (error) {
          console.error(error);
        }
      },
    });
  };

  const _getRecipientName = () => {
    if (transfer.destinationPaymentDetails.accountBeneficiary) {
      return transfer.destinationPaymentDetails.accountBeneficiary;
    }

    return undefined;
  };

  const _getDestinationBlockchainNetwork = () => {
    if (transfer.destinationNetwork !== 'fiat') {
      return transfer.destinationNetwork;
    }

    return undefined;
  };

  const _getPaymentStatus = () => {
    if (transfer?.payablePaymentStatus === 'success') {
      return 'paid';
    }

    if (
      ['executed', 'awaiting_execution'].includes(
        transfer?.payablePaymentStatus
      )
    ) {
      return 'pending';
    }

    return 'unpaid';
  };

  return (
    <Drawer
      closable
      destroyOnClose
      width={540}
      zIndex={10}
      title={'Transfer Overview'}
      placement="right"
      open={!!transfer}
      onClose={onClose}>
      {!!transfer && (
        <div className="relative flex-1 space-y-6">
          <PayoutDetailsWidget
            recipientName={_getRecipientName()}
            destinationAmount={transfer.transferAmount}
            destinationCurrency={transfer.destinationCurrency}
            destinationBlockchainNetwork={_getDestinationBlockchainNetwork()}
            destinationBankAccount={
              transfer?.destinationPaymentDetails?.type === 'bankAccount'
                ? transfer?.destinationPaymentDetails
                : undefined
            }
            destinationWalletAddress={
              transfer?.destinationPaymentDetails?.address
            }
            onPayButtonPress={() => {
              onCompleteTransferClick();
              onClose();
            }}
            paymentStatus={_getPaymentStatus()}
          />

          {isCryptoCurrency(transfer?.destinationCurrency) && (
            <OnrampDepositDetailsSlideOverWidget
              onrampPaymentStatus={transfer?.payablePaymentStatus}
              onrampPaymentMethod={transfer?.payablePaymentMethod}
              paymentProviderResponse={
                transfer?.payablePaymentPaymentProviderResponse
              }
            />
          )}

          <DetailSection header="Other Actions">
            <DetailSection.Item term="Delete Transfer">
              <button
                onClick={handleDelete}
                type="button"
                className="font-medium text-rose-500  hover:text-rose-400">
                Delete Now
              </button>
            </DetailSection.Item>
          </DetailSection>
        </div>
      )}
    </Drawer>
  );
};
